import { BannerRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * bannerOnSaveData - Function that saves on database a new banner
 * /banners
 * method POST
 * @async-function
 */
const bannerOnSaveData = async (token: string, model: BannerRequestType) => {
    const response = await api.post(
        `/banners`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default bannerOnSaveData;
